import { Component, Input, OnDestroy } from '@angular/core';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Subscription, from } from 'rxjs';
import { MeetingSchedulerStoreService } from '../../data-providers/meeting-scheduler-store.service';
import { DurationOption } from '../duration-multi-select/duration-multi-select.component';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { POSTHOG_ACTIONS, POSTHOG_CATEGORIES, POSTHOG_KEYS } from '../../constants';

@Component({
  selector: 'meeting-scheduler-settings-meeting-before-buffer-card',
  templateUrl: './meeting-before-buffer-card.component.html',
  standalone: false,
})
export class MeetingBeforeBufferCardComponent implements OnDestroy {
  @Input() bufferDurationBeforeMeeting: number;
  @Input() enableTracking: boolean;

  options: DurationOption[] = [
    { seconds: 0, label: '0' },
    { seconds: 300, label: '5' },
    { seconds: 600, label: '10' },
    { seconds: 900, label: '15' },
    { seconds: 1800, label: '30' },
    { seconds: 3600, label: '60' },
  ];

  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly meetingSchedulerService: MeetingSchedulerStoreService,
    private readonly alertService: SnackbarService,
    private readonly analyticsService: ProductAnalyticsService,
  ) {}

  onDurationSelected(option: DurationOption): void {
    this.subscriptions.push(
      from(
        this.meetingSchedulerService.updateUserPreferences({ bufferDurationBeforeMeeting: option.seconds }),
      ).subscribe({
        next: () => {
          if (this.enableTracking) {
            this.analyticsService.trackEvent(
              POSTHOG_KEYS.HOST_PREFERENCE_UPDATED,
              POSTHOG_CATEGORIES.USER,
              POSTHOG_ACTIONS.CLICK,
            );
          }
          this.alertService.openSuccessSnack(
            'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.ALERTS.BUFFER_DURATION_BEFORE_MEETING.SUCCESS',
          );
        },
        error: () =>
          this.alertService.openErrorSnack(
            'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.ALERTS.BUFFER_DURATION_BEFORE_MEETING.ERROR',
          ),
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
}
